// extracted by mini-css-extract-plugin
export default {"rtl-modal":"ConfirmationModal_rtl-modal__qScbu","modal-body":"ConfirmationModal_modal-body__zdxjV"};